import { FileCollectionT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { isMobile } from '../../../../utils/app.helper';

type Props={
    object?: ObjectContainerClientT;
    fileCollections?: FileCollectionT[];
    wide?: boolean;
};

const SidebarFloorPlan: React.FC<Props> = ({ object, fileCollections, wide = false }): ReactElement => {
    const firstCollectionFile = fileCollections?.find(fc =>
        fc.id === object?.floorPlanCollectionId
    )?.files?.slice().sort((a, b) => {
        return a.sortOrder - b.sortOrder;
    })[0];
    const url = (firstCollectionFile?.type === 'image' && firstCollectionFile?.url?.medium) || '';

    return (
        <>
            {object && url && <div className={'bv-sidebar-content-floorplan-container'} style={{ maxHeight: 'unset' }}>
                <img className={'bv-sidebar-content-floorplan-container-img'} alt='' src={url} />
            </div>}
        </>
    );
};


export default SidebarFloorPlan;